/*
 * Hollence VIP offer + cart guard
 * - Product page: bundle tiers, VIP / just-this-order choice, live prices, add to cart
 *   (adds the selected variant x quantity, plus the VIP membership product once).
 * - Sitewide: keeps the membership line at quantity 1 and removes it if it is alone in the cart.
 */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function money(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    function fmt(n, dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  // Shopify takes percentage discounts off the line total and rounds the discount down.
  function pctOff(cents, pct) { return cents - Math.floor(cents * pct / 100); }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function pub(name, data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[name]) publish(PUB_SUB_EVENTS[name], data);
    } catch (e) {}
  }
  function sub(name, fn) {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[name]) { subscribe(PUB_SUB_EVENTS[name], fn); return true; }
    } catch (e) {}
    return false;
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  function drawerSections() {
    var d = drawer();
    try { return d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; } catch (e) { return []; }
  }
  function renderDrawer(state, open) {
    var d = drawer();
    if (!d || !state.sections) return false;
    try {
      if (open && typeof d.renderContents === 'function') {
        d.classList.remove('is-empty');
        d.renderContents(state);
        return true;
      }
      if (typeof d.getSectionsToRender === 'function' && typeof d.getSectionInnerHTML === 'function') {
        d.getSectionsToRender().forEach(function (s) {
          var el = (s.selector && document.querySelector(s.selector)) || document.getElementById(s.id);
          if (el && state.sections[s.id] != null) el.innerHTML = d.getSectionInnerHTML(state.sections[s.id], s.selector);
        });
        d.classList.toggle('is-empty', state.item_count === 0);
        return true;
      }
    } catch (e) { console.warn('[hollence] drawer render', e); }
    return false;
  }

  /* ---------- product page offer ---------- */
  // Tier model: tiers[i] = { qty, label, std: cents, mem: cents, stdVariant, memVariant }
  function Offer(root) {
    var cfgEl = $(root, '[data-hl-offer-config]');
    if (!cfgEl) return;
    var c;
    try { c = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    this.root = root;
    this.c = c;
    this.mode = c.mode;
    this.variant = this.findVariant(c.variantId) || c.variants[0];
    this.tier = 0;
    if (c.variantMode) {
      var pv = this.variant.options[c.packIdx];
      this.tier = Math.max(0, c.packValues.indexOf(pv));
    }
    this._lastDom = String(this.variant.id);
    this.bind();
    this.render();
  }
  Offer.prototype.findVariant = function (id) {
    id = Number(id);
    for (var i = 0; i < this.c.variants.length; i++) if (this.c.variants[i].id === id) return this.c.variants[i];
    return null;
  };
  Offer.prototype.memberLocked = function () { return this.c.isMember || this.c.clubInCart; };
  Offer.prototype.effectiveMode = function () { return this.c.showVip && (this.memberLocked() || this.mode === 'member') ? 'member' : 'standard'; };
  Offer.prototype.packQty = function (value, i) {
    var n = parseInt(String(value), 10);
    return n > 0 ? n : i + 1;
  };
  // Find the variant with the current non-pack/non-pricing options and the given pack + pricing values.
  Offer.prototype.match = function (packValue, pricingValue) {
    var c = this.c, cur = this.variant.options, best = null;
    for (var i = 0; i < c.variants.length; i++) {
      var w = c.variants[i], ok = true;
      for (var o = 0; o < w.options.length; o++) {
        var want = o === c.packIdx ? packValue : (o === c.pricingIdx ? pricingValue : cur[o]);
        if (w.options[o] !== want) { ok = false; break; }
      }
      if (ok) { best = w; break; }
    }
    return best;
  };
  Offer.prototype.tiers = function () {
    var c = this.c, self = this, out = [];
    if (c.variantMode) {
      c.packValues.forEach(function (pv, i) {
        var s = self.match(pv, c.standardValue), m = self.match(pv, c.memberValue);
        out.push({ qty: self.packQty(pv, i), label: pv, std: s ? s.price : 0, mem: m ? m.price : (s ? s.price : 0), stdVariant: s, memVariant: m || s });
      });
      return out;
    }
    var v = this.variant, n = c.tiersEnabled ? 4 : 1;
    for (var i = 0; i < n; i++) {
      var q = i + 1, tp = c.calcMode ? (c.tierPct[i] || 0) : 0, line = v.price * q;
      var memLine = pctOff(line, c.pct);
      out.push({ qty: q, label: String(q), std: pctOff(line, tp),
        mem: c.tiersOnMember ? pctOff(memLine, tp) : memLine, stdVariant: v, memVariant: v });
    }
    return out;
  };
  Offer.prototype.bind = function () {
    var self = this, root = this.root, sid = this.c.sectionId;
    $$(root, 'input[name="hl-qty-' + sid + '"]').forEach(function (inp) {
      inp.addEventListener('change', function () { self.tier = (Number(inp.value) || 1) - 1; self.render(); self.syncPicker(); });
    });
    $$(root, 'input[name="hl-plan-' + sid + '"]').forEach(function (inp) {
      inp.addEventListener('change', function () { self.mode = inp.value; self.render(); self.syncPicker(); });
    });
    var atc = $(root, '[data-hl-atc]');
    if (atc) atc.addEventListener('click', function () { self.add(); });

    sub('variantChange', function (evt) {
      var v = evt && evt.data && evt.data.variant;
      if (v && (!evt.data.sectionId || evt.data.sectionId === sid)) self.setVariant(v.id, true);
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || self._syncing) return;
      if (t.name === 'id' && t.value) return self.setVariant(t.value, true);
      if (t.closest && t.closest('variant-selects, variant-radios')) setTimeout(function () { self.syncFromDom(); }, 120);
    });
    this._poll = setInterval(function () { if (!document.hidden) self.syncFromDom(); }, 700);
  };
  Offer.prototype.syncFromDom = function () {
    var sid = this.c.sectionId;
    var input = document.querySelector('#product-form-' + sid + ' input[name="id"]') ||
                document.querySelector('form[id^="product-form-' + sid + '"] input[name="id"]');
    var id = (input && input.value) || new URLSearchParams(location.search).get('variant');
    if (id && id !== this._lastDom) { this._lastDom = id; this.setVariant(id, true); }
  };
  // fromPicker: the theme's own picker changed the variant (e.g. a new colour).
  Offer.prototype.setVariant = function (id, fromPicker) {
    var v = this.findVariant(id), c = this.c;
    if (!v || v === this.variant) return;
    this.variant = v;
    if (c.variantMode && fromPicker) {
      var i = c.packValues.indexOf(v.options[c.packIdx]);
      if (i > -1) this.tier = i;
    }
    this.render();
  };
  // Keep the theme's (hidden) Pack / Pricing pickers in step, so gallery, URL and sticky bar match.
  Offer.prototype.syncPicker = function () {
    var c = this.c;
    if (!c.variantMode) return;
    var target = this.selected();
    if (!target) return;
    var sid = c.sectionId, self = this;
    [c.packIdx, c.pricingIdx].forEach(function (oi) {
      var value = target.options[oi];
      var box = document.getElementById('variant-selects-' + sid);
      if (!box) return;
      var radios = $$(box, 'input[type="radio"]').filter(function (r) { return r.id.indexOf(sid + '-' + (oi + 1) + '-') === 0; });
      var r = radios.filter(function (x) { return x.value === value; })[0];
      if (r && !r.checked) {
        self._syncing = true;
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        self._syncing = false;
      }
      var sel = $$(box, 'select').filter(function (x) { return $$(x, 'option').some(function (o) { return o.value === value; }) && x.name && x.name.toLowerCase().indexOf(String(oi === c.packIdx ? 'pack' : 'pricing')) > -1; })[0];
      if (sel && sel.value !== value) {
        self._syncing = true;
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        self._syncing = false;
      }
    });
    this._lastDom = String(target.id);
  };
  Offer.prototype.selected = function () {
    var t = this.tiers()[this.tier] || this.tiers()[0];
    if (!t) return this.variant;
    return this.effectiveMode() === 'member' ? t.memVariant : t.stdVariant;
  };
  Offer.prototype.render = function () {
    var root = this.root, c = this.c, f = c.moneyFormat, self = this;
    var mode = this.effectiveMode();
    var tiers = this.tiers();
    if (this.tier >= tiers.length) this.tier = 0;
    var t = tiers[this.tier], base = tiers[0];
    root.classList.toggle('is-member', mode === 'member');

    // tier cards
    $$(root, '[data-hl-tier]').forEach(function (el) {
      var i = Number(el.getAttribute('data-hl-tier')) - 1, tt = tiers[i];
      if (!tt) return;
      var total = mode === 'member' ? tt.mem : tt.std;
      var full = (mode === 'member' ? base.mem : base.std) * tt.qty;
      el.classList.toggle('is-selected', i === self.tier);
      $(el, '[data-hl-tier-total]').textContent = money(total, f);
      $(el, '[data-hl-tier-each]').textContent = money(Math.floor(total / tt.qty), f) + ' each';
      var save = $(el, '[data-hl-tier-save]');
      if (save) save.textContent = full > total && i > 0 ? 'Save ' + Math.round((1 - total / full) * 100) + '%' : '';
      var input = $(el, 'input');
      if (input) input.checked = i === self.tier;
    });
    // steps + hint use the real savings of each pack against single items
    var savings = tiers.map(function (tt) {
      var full = base.std * tt.qty;
      return full > 0 ? Math.max(0, Math.round((1 - tt.std / full) * 100)) : 0;
    });
    $$(root, '[data-hl-step]').forEach(function (el, i) {
      el.classList.toggle('is-on', i <= self.tier);
      if (i > 0) el.textContent = savings[i] > 0 ? savings[i] + '% off' : tiers[i].qty + ' items';
    });
    var fill = $(root, '[data-hl-fill]');
    if (fill) fill.style.setProperty('--hl-fill', String(tiers.length > 1 ? this.tier / (tiers.length - 1) : 0));
    var hint = $(root, '[data-hl-hint]');
    if (hint) {
      var next = this.tier + 1 < tiers.length ? this.tier + 1 : -1;
      if (next > -1 && savings[next] > 0) hint.textContent = 'Add ' + (tiers[next].qty - t.qty) + ' more to save ' + savings[next] + '%';
      else if (savings[this.tier] > 0) hint.textContent = 'Best value unlocked: ' + savings[this.tier] + '% off';
      else hint.textContent = '';
    }

    // once VIP is in the cart, the choice is replaced by a short note
    var locked = this.memberLocked();
    var lockedNote = $(root, '[data-hl-plan-locked]');
    if (lockedNote) {
      lockedNote.hidden = !locked;
      $$(root, '.hl-plan__options, [data-hl-info]').forEach(function (el) { el.style.display = locked ? 'none' : ''; });
    }
    // plan options show the price of the selected bundle
    $$(root, '[data-hl-plan]').forEach(function (el) { el.classList.toggle('is-selected', el.getAttribute('data-hl-plan') === mode); });
    $$(root, '[data-hl-plan-member]').forEach(function (el) { el.textContent = money(t.mem, f); });
    $$(root, '[data-hl-plan-std]').forEach(function (el) { el.textContent = money(t.std, f); });
    $$(root, '[data-hl-plan-saving]').forEach(function (el) { el.textContent = money(Math.max(0, t.std - t.mem), f); });
    $$(root, 'input[name="hl-plan-' + c.sectionId + '"]').forEach(function (inp) { inp.checked = inp.value === mode; });
    $$(root, '[data-hl-info]').forEach(function (el) { el.hidden = el.getAttribute('data-hl-info') !== mode; });
    var consent = $(root, '[data-hl-consent]');
    if (consent) consent.hidden = !(mode === 'member' && !this.memberLocked());

    // total: selected bundle; struck-through = single standard price x quantity
    var total = mode === 'member' ? t.mem : t.std;
    var was = base.std * t.qty;
    $(root, '[data-hl-total]').textContent = money(total, f);
    var wasEl = $(root, '[data-hl-total-was]');
    if (wasEl) { wasEl.hidden = !(was > total); wasEl.textContent = money(was, f); }

    // price summary block (single item)
    $$(document, '[data-hl-psum="' + c.sectionId + '"]').forEach(function (ps) {
      $$(ps, '[data-hl-psum-member]').forEach(function (el) { el.textContent = money(base.mem, f); });
      $$(ps, '[data-hl-psum-std]').forEach(function (el) { el.textContent = money(base.std, f); });
    });

    // button
    var sel = this.selected();
    var atc = $(root, '[data-hl-atc]'), label = $(root, '[data-hl-atc-label]');
    if (atc && !atc.classList.contains('is-loading')) {
      var ok = sel && sel.available;
      atc.disabled = !ok;
      label.textContent = ok ? 'Add to cart · ' + money(total, f) : 'Sold out';
    }
  };
  Offer.prototype.error = function (msg) {
    var el = $(this.root, '[data-hl-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  };
  Offer.prototype.add = function () {
    var self = this, c = this.c, atc = $(this.root, '[data-hl-atc]');
    var sel = this.selected(), t = this.tiers()[this.tier];
    if (!sel || !sel.available || atc.classList.contains('is-loading')) return;
    var mode = this.effectiveMode();
    var wantClub = c.showVip && !c.isMember && mode === 'member' && c.clubVariantId;
    var qty = c.variantMode ? 1 : t.qty;   // a pack variant already contains its quantity
    this.error('');
    atc.classList.add('is-loading');
    atc.setAttribute('aria-busy', 'true');

    var cartCheck = wantClub ? getJSON('/cart.js').catch(function () { return { items: [] }; }) : Promise.resolve({ items: [] });
    cartCheck.then(function (cart) {
      var hasClub = (cart.items || []).some(function (i) { return i.product_id === c.clubProductId || i.variant_id === c.clubVariantId; });
      var items = [{ id: sel.id, quantity: qty }];
      if (wantClub && !hasClub) items.push({ id: c.clubVariantId, quantity: 1 });
      var sections = drawerSections();
      var body = { items: items };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j, club: items.length > 1 }; }); });
    }).then(function (res) {
      if (!res.ok || res.data.status) {
        var msg = res.data.description || res.data.message || 'Something went wrong. Please try again.';
        if (res.club && /hollence|club|vip|sold out|not available|unavailable/i.test(msg)) {
          msg = 'VIP can’t be added right now. Choose “Just this order” or try again in a moment.';
        }
        self.error(msg);
        return;
      }
      if (wantClub) c.clubInCart = true;
      var cfg = clubCfg();
      var codeStep = (mode === 'member' && c.showVip) ? getJSON('/cart.js').then(function (cart) { return syncCode(cart, cfg, true); }).catch(function () { return null; }) : Promise.resolve(null);
      return codeStep.then(function (codeState) {
        pub('cartUpdate', { source: 'hollence-guard', productVariantId: sel.id, cartData: res.data });
        var sections = (codeState && codeState.sections) || res.data.sections;
        var state = { id: sel.id, sections: sections };
        if (!renderDrawer(state, true)) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
    }).catch(function () {
      self.error('Connection problem. Please try again.');
    }).then(function () {
      atc.classList.remove('is-loading');
      atc.removeAttribute('aria-busy');
      self.render();
    });
  };

  /* ---------- sitewide cart guard ---------- */
  // Rules: membership line stays at quantity 1; it is removed when nothing else is in the cart;
  // Member-priced variants are swapped to Standard when the membership leaves the cart (non-members),
  // and Standard lines are swapped to Member when VIP is added from the cart.
  var guardBusy = false;
  function clubCfg() {
    var el = document.getElementById('HollenceClubConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function withSections(body) {
    var sections = drawerSections();
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return body;
  }
  function pricingOf(item, cfg) {
    var o = (item.options_with_values || []).filter(function (x) { return String(x.name).toLowerCase() === String(cfg.pricingName).toLowerCase(); })[0];
    return o ? o.value : null;
  }
  // Find the sibling variant of a cart line with a different Pricing value.
  function sibling(item, cfg, wantValue) {
    return getJSON('/products/' + item.handle + '.js').then(function (p) {
      var idx = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); }).indexOf(String(cfg.pricingName).toLowerCase());
      if (idx < 0) return null;
      var cur = null;
      p.variants.forEach(function (v) { if (v.id === item.variant_id) cur = v; });
      if (!cur) return null;
      var opts = cur.options.slice(); opts[idx] = wantValue;
      var found = null;
      p.variants.forEach(function (v) { if (!found && v.options.join('|') === opts.join('|')) found = v; });
      return found;
    }).catch(function () { return null; });
  }
  function swapLines(lines, cfg, wantValue) {
    // Sequential: remove the line, add its sibling with the same quantity.
    var chain = Promise.resolve(null);
    lines.forEach(function (item) {
      chain = chain.then(function () {
        return sibling(item, cfg, wantValue).then(function (sib) {
          if (!sib) return null;
          return post('/cart/change.js', { id: item.key, quantity: 0 }).then(function () {
            return post('/cart/add.js', { items: [{ id: sib.id, quantity: item.quantity }] });
          });
        });
      });
    });
    return chain;
  }
  function refresh(open) {
    // Re-render the drawer from the current cart.
    return post('/cart/update.js', withSections({ updates: {} })).then(function (state) {
      if (!renderDrawer(state, open) && /\/cart\/?$/.test(location.pathname)) location.reload();
      var d = drawer(), bubble = document.getElementById('cart-icon-bubble');
      if (bubble && d && d.getSectionInnerHTML && state.sections && state.sections['cart-icon-bubble']) {
        bubble.innerHTML = d.getSectionInnerHTML(state.sections['cart-icon-bubble'], '.shopify-section');
      }
      return state;
    });
  }
  // VIP pricing is a Shopify discount code (Discounts > VIPCLUB-MEMBER) that the theme keeps in the
  // cart while the membership is in it, and takes out when it leaves. Other codes are left alone.
  function vipCode(cfg) { return String(cfg && cfg.vipCode || '').trim(); }
  function sameCode(a, b) { return String(a).toUpperCase() === String(b).toUpperCase(); }
  function syncCode(cart, cfg, want) {
    var code = vipCode(cfg);
    if (!code) return Promise.resolve(null);
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var has = codes.some(function (x) { return sameCode(x, code); });
    if (want === has) return Promise.resolve(null);
    var next = want ? codes.concat([code]) : codes.filter(function (x) { return !sameCode(x, code); });
    return post('/cart/update.js', withSections({ discount: next.join(',') }));
  }
  function guard() {
    var cfg = clubCfg();
    if (!cfg || !cfg.productId || guardBusy) return Promise.resolve();
    guardBusy = true;
    return getJSON('/cart.js').then(function (cart) {
      var club = null, others = 0, memberLines = [];
      (cart.items || []).forEach(function (i) {
        if (i.product_id === cfg.productId) { club = i; return; }
        others += i.quantity;
        if (pricingOf(i, cfg) === cfg.memberValue) memberLines.push(i);
      });
      var jobs = Promise.resolve(), changed = false;
      if (club && others === 0) {
        changed = true; jobs = post('/cart/change.js', { id: club.key, quantity: 0 });
      } else if (club && club.quantity !== 1) {
        changed = true; jobs = post('/cart/change.js', { id: club.key, quantity: 1 });
      }
      if (!club && !cfg.isMember && memberLines.length) {
        changed = true; jobs = jobs.then(function () { return swapLines(memberLines, cfg, cfg.standardValue); });
      }
      var wantCode = others > 0 && (!!club || !!cfg.isMember);
      return jobs.then(function () {
        return changed ? getJSON('/cart.js') : cart;
      }).then(function (now) {
        return syncCode(now, cfg, wantCode);
      }).then(function (state) {
        if (state && !state.status) changed = true;
        if (changed) return refresh(false);
      });
    }).catch(function () {}).then(function () { guardBusy = false; });
  }
  function addClubFromCart(btn) {
    var cfg = clubCfg();
    if (!cfg || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    guardBusy = true;
    getJSON('/cart.js').then(function (cart) {
      var stdLines = (cart.items || []).filter(function (i) { return i.product_id !== cfg.productId && pricingOf(i, cfg) === cfg.standardValue; });
      return post('/cart/add.js', { items: [{ id: cfg.variantId, quantity: 1 }] }).then(function (res) {
        if (res.status) { btn.textContent = 'VIP is unavailable right now'; return; }
        return swapLines(stdLines, cfg, cfg.memberValue);
      });
    }).then(function () { return getJSON('/cart.js'); })
      .then(function (cart) { return syncCode(cart, cfg, true); })
      .then(function () { return refresh(false); })
      .catch(function () {})
      .then(function () { guardBusy = false; btn.removeAttribute('aria-busy'); pub('cartUpdate', { source: 'hollence-guard' }); });
  }

  function init() {
    document.querySelectorAll('[data-hl-offer]').forEach(function (el) {
      if (!el.__hlOffer) el.__hlOffer = new Offer(el);
    });
    sub('cartUpdate', function (e) { if (!e || e.source !== 'hollence-guard') setTimeout(guard, 250); });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('cart-remove-button, .cart-remove-button, .quantity__button');
      if (t) setTimeout(guard, 900);
      var add = e.target && e.target.closest && e.target.closest('[data-hl-add-club]');
      if (add) addClubFromCart(add);
    });
    // Sticky add-to-cart bar scrolls to the offer instead of adding without a plan choice.
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.sticky-atc__scroll-btn');
      var offer = document.querySelector('[data-hl-offer]');
      if (!b || !offer) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = offer.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }, true);
    guard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.HollenceOffer = { money: money, guard: guard };
})();
